import { jsx as _jsx } from "react/jsx-runtime";
import { useLoadingScreenContext } from "../../loading-screen-context";
import { StyledLoadingOverlayComponent } from "./loading-overlay-component.scss";
import BookAMeetingLoadingScreen from "./loading-screen-types/book-a-meeting-loading-screen/book-a-meeting-loading-screen";
import { LOADER_TYPES } from "contexts/types/loader-types";
const altLoadingScreenContentText = "Loading, please wait...";
const LOADING_SCREEN_TYPES_TO_LOADER = {
    [LOADER_TYPES.BOOK_A_MEETING]: /*#__PURE__*/ _jsx(BookAMeetingLoadingScreen, {}),
    [LOADER_TYPES.DEFAULT]: /*#__PURE__*/ _jsx("p", {
        children: altLoadingScreenContentText
    })
};
const LoadingOverlayComponent = ()=>{
    const { isLoadingScreen, loadingScreenType } = useLoadingScreenContext();
    if (!isLoadingScreen) return null;
    return /*#__PURE__*/ _jsx(StyledLoadingOverlayComponent, {
        children: LOADING_SCREEN_TYPES_TO_LOADER[loadingScreenType] || LOADING_SCREEN_TYPES_TO_LOADER[LOADER_TYPES.DEFAULT]
    });
};
export default LoadingOverlayComponent;
